import { Component, OnInit, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import * as _ from 'lodash';

//common component
import { ToastComponent } from '../../../../../../../common/toast.component';
//Common values
import { displayValues, toastMsg } from '../../../../../../../utils';
//model
import { SolutionDescriptionInitialDM } from '../../../../../../../models';

//Service File 
import { SideNavService } from '../../../../sidenav.service';
import { MatDialog } from '@angular/material';
import { SolutionDescriptionAuditLogComponent } from '../solution-description-audit-log/solution-description-audit-log.component';

@Component({
  selector: 'spekwo-solution-description-form',
  templateUrl: './solution-description-form.component.html',
  styleUrls: ['./solution-description-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SolutionDescriptionFormComponent implements OnInit {

  @Output() submittedValues = new EventEmitter<{ SolutionDescriptionInitialDM: SolutionDescriptionInitialDM, primaryCategory: any, subCategory: any }>();

  @Output() primCategory = new EventEmitter<any>();
  @Output() subCategory = new EventEmitter<any>();

  @Input() defaultFormValues: SolutionDescriptionInitialDM;

  @Input() formType: string;
  @Input() screen: string;

  displayValues = displayValues;
  solutionFields: SolutionDescriptionInitialDM = Object.assign({}, initialValues);

  enableSave: boolean = false;
  selectedCostOption: string = '';
  selectedPrimarycategory: any = '';
  primaryCategory: any = '';
  tmCostOption: string[] = ['tm', 'Flat', 'foot'];
  tableType: string = 'create';
  toastMsg = toastMsg;
  loadComponent: boolean = false;

  primaryCategories: any;
  subCategories: any;
  primaryCategoriesList: any;
  dialogRef: any;

  constructor(private _toastComponent: ToastComponent,
    private _sideNavService: SideNavService,
    private dialog: MatDialog,
  ) {
    this.primaryCategoryfliter('');
  }




  ngOnInit() {
    this.assignInitialFormValues();
    this._sideNavService.onSolutionInfo.next(true);
  }

  //Assigning initial values if the form type is edit
  assignInitialFormValues() {
    if (this.formType == 'edit') {
      this.solutionFields = Object.assign({}, this.defaultFormValues);

      this._sideNavService.getAllCategories().then((response: any) => {
        if (response && response.data && response.data.allWccategories && response.data.allWccategories.nodes && response.data.allWccategories.nodes.length > 0) {

          let check = _.filter(response.data.allWccategories.nodes, data => {
            if (this.defaultFormValues.keyPrimCategory.toUpperCase().trim() === data.category.trim()) {
              return data.categoryid;
            }
          }
          );
          if (check && check.length > 0 && check[0].categoryid) {
            this.getAllSubCategories(check[0].categoryid);
          }
        }
      });


      this.selectedCostOption = this.defaultFormValues.costOption;
      this.primaryCategory = this.defaultFormValues.keyPrimCategory;
      this.enableSave = true;
      this.tableType = 'edit';
    }
  }

  //Save button enable conditions
  onSaveCheck(event) {
    if (this.solutionFields.costOption.length == 0 || this.solutionFields.keyPrimCategory.length == 0
      || this.solutionFields.key1.length == 0 || this.solutionFields.subcategory.length == 0 || this.solutionFields.key2.length == 0
      || this.solutionFields.solution.length == 0 || !this.solutionFields.totalCost || !event) {
      this.enableSave = false;
    }
    else {
      this.enableSave = true;
    }
  }


  selectPrimaryCategory(event) {

    let check = _.filter(this.primaryCategories, data => {
      if (event.option.value === data.categoryid) {
        return data.categoryid;
      }
    }
    );
    if (check && check.length > 0) {
      // this.primaryCategory  = check[0].category;
      this.solutionFields.keyPrimCategory = check[0].category;
      this.solutionFields.categoryid = check[0].categoryid;
      this.onSaveCheck('');
    }

    //for sub 

    let categoryId = this.solutionFields.categoryid
    this.getAllSubCategories(categoryId);

    this.primaryCategories = [];
  }

  getAllSubCategories(categoryId) {
    this._sideNavService.getAllSubCategories(categoryId).then(
      (response: any) => {
        if (response && response.data && response.data.allWcsubcategories && response.data.allWcsubcategories.nodes && response.data.allWcsubcategories.nodes.length > 0) {
          this.subCategories = response.data.allWcsubcategories.nodes;
          if (response && response.data && response.data.allWcsubcategories && response.data.allWcsubcategories.nodes && response.data.allWcsubcategories.nodes.length > 0 && response.data.allWcsubcategories.nodes[0].subcategory) {
            if (this.formType != 'edit') {

              this.solutionFields.subcategory = response.data.allWcsubcategories.nodes[0].subcategory;
            }
          }
        }
        else {
          this.subCategories = [];
          this.solutionFields.subcategory = '';
        }


      }

    ).catch((err) => {
      console.log(err);
    });
  }



  primaryCategoryfliter(event) {
    let searchCategory = event;
    //Fliter Primary Categories 
    if (typeof (searchCategory) !== 'number') {

      this._sideNavService.searchPrimaryCategories(searchCategory).then(
        (response: any) => {
          if (response && response.data && response.data.allWccategories && response.data.allWccategories.nodes && response.data.allWccategories.nodes.length > 0) {
            this.primaryCategories = response.data.allWccategories.nodes;
            this.primaryCategoriesList = response.data.allWccategories.nodes;
          }
        }
      ).catch((err) => {
        console.log(err);
      });
    }
  }

  selectSubCategory(event) {
    this.solutionFields.subcategory = event.option.value;
    this.onSaveCheck('');
  }



  // Cost selection dropdown
  costSelection(selected: string) {
    //Resetting cost values while changing cost option
    if (this.solutionFields.costOption.length > 0) {
      this._toastComponent.showToast(this.toastMsg.changingCostOptionWarning);
      this.solutionFields.cpf = null;
      this.solutionFields.cpi = null;
      this.solutionFields.hourRate = null;
      this.solutionFields.laborHour = null;
      this.solutionFields.labourCost = null;
      this.solutionFields.tf = null;
      this.solutionFields.totalCost = null;
      this.tableType = 'create';
    }
    this.solutionFields.costOption = selected;
    this.onSaveCheck(selected);
    this.selectedCostOption = selected;
  }

  //Assigning cost values
  calculatedCostValues(event: any) {
    _.map(event, (value, key) => {
      this.solutionFields[key] = value;
    });
    this.onSaveCheck(event.totalCost);
  }

  //To close the cost table
  closeEstimateTable(event) {
    if (event) {
      this.selectedCostOption = '';
    }
  }

  viewEstimateTable() {
    this.tableType = 'edit';
    this.selectedCostOption = this.solutionFields.costOption;
  }


  //Emit form values to paren component
  onSubmitFile() {
    console.log(this.solutionFields),
      this.submittedValues.emit({ SolutionDescriptionInitialDM: this.solutionFields, primaryCategory: this.primaryCategoriesList, subCategory: this.subCategories });
    console.log("this.submittedValues", this.submittedValues)
  }

  loadSolutionDescriptionList() {
    this.loadComponent = !this.loadComponent;
  }

  viewLog() {
    this.dialogRef = this.dialog.open(SolutionDescriptionAuditLogComponent, {
      width: 'calc(100% - 20%)',
      height: 'calc(100% - 25%)',
      panelClass: 'log-info-dialog',

    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
      })
  }

}

//Default Values
const initialValues: SolutionDescriptionInitialDM = {
  keyword: [],
  solution: '',
  cost: null,
  keyPrimCategory: '',
  subcategory: '',
  key1: '',
  keyPhrase: '',
  key2: '',
  key3: '',
  key4: '',
  irl: '',
  costOption: '',
  labourCost: null,
  hourRate: null,
  laborHour: null,
  materialCost: null,
  ni: null,
  tf: null,
  cpi: null,
  cpf: null,
  categoryid: null,

}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-form/solution-description-form.component.ts